let desktopModals = document.querySelectorAll(".desktop-modal-link");

if (desktopModals) {

	desktopModals.forEach(item => {

		item.addEventListener("click", (event) => {
			if (window.innerWidth > 767) {
				event.preventDefault();
				let modalLink = "#m-" + item.dataset.name;
				$(modalLink).modal("show");
			}
		});

	});

}
